// extracted by mini-css-extract-plugin
module.exports = {"shopini-logistics":"styles_shopini-logistics__1_baT","title":"styles_title__mlAZ4","sub-title":"styles_sub-title__1oYS4","btn-overrides":"styles_btn-overrides__Dk4lA"};